import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import {
  Button,
  Message,
  Menu,
  Icon,
  Modal
} from 'semantic-ui-react'

const modalTrigger = ({
  type = 'user',
  iconName = 'add',
  iconHeader = 'Add User'
}) => (
  <Menu.Item name={'add_' + type} >
    <Icon name={iconName} />
    {iconHeader}
  </Menu.Item>
)

modalTrigger.propTypes = {
  type: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  iconHeader: PropTypes.string.isRequired
}

const FetchMessage = ({
  type
}) => (
  <Message icon attached='top' >
    <Icon name='circle notched' loading />
    <Message.Content>
      <Message.Header>Creating {type}...</Message.Header>
    </Message.Content>
  </Message>
)

FetchMessage.propTypes = {
  type: PropTypes.string.isRequired
}

const ErrMessage = ({
  errorMessage,
  onDismiss,
  type
}) => (
  <Message error onDismiss={onDismiss} attached='top' >
    <Message.Header>There was an error creating (a) new {type}</Message.Header>
    <p>{errorMessage}</p>
  </Message>
)

ErrMessage.propTypes = {
  type: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired
}

const AddMessage = R.cond([
  [R.both(R.propEq('visible', true), R.propEq('fetching', true)), FetchMessage],
  [R.both(R.propEq('visible', true), R.has('errorMessage')), ErrMessage],
  [R.T, R.always(null)]
]) // ({visibile, fetching, errorMessage, onDismiss, type})

AddMessage.propTypes = {
  type: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  fetching: PropTypes.bool,
  errorMessage: PropTypes.string,
  onDismiss: PropTypes.func
}

const CreateModal = ({
  open = false,
  onOpen,
  onClose,
  onMount,
  type,
  iconName,
  iconHeader,
  errorMessage,
  visible,
  fetching,
  onDismiss,

  header,
  subHeader,

  children,
  trigger
}) => (
  <Modal
    open={open}
    onClose={onClose}
    closeOnDimmerClick={false}
    onOpen={onOpen}
    onMount={onMount || null}
    trigger={trigger || modalTrigger({
      type,
      iconName,
      iconHeader
    })}
  >
    <AddMessage
      errorMessage={errorMessage}
      visible={visible}
      fetching={fetching}
      onDismiss={onDismiss}
      type={type}
    />
    <Modal.Header>{header || 'Create a new ' + type}
      <Button basic
        icon='close'
        floated='right'
        onClick={onClose}
      />
      {subHeader ? <p>{subHeader}</p> : null }
    </Modal.Header>
    <Modal.Content image>
      <Modal.Description style={ { maxWidth: '100%' }} >
        {children}
      </Modal.Description>
    </Modal.Content>
  </Modal>
)

CreateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,

  type: PropTypes.string.isRequired,
  header: PropTypes.string,
  subHeader: PropTypes.string,
  iconName: PropTypes.string,
  iconHeader: PropTypes.string,

  // message vars
  visible: PropTypes.bool,
  fetching: PropTypes.bool,
  errorMessage: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  onMount: PropTypes.func,

  // what we wrap
  children: PropTypes.element.isRequired,
  trigger: PropTypes.element
}

export default CreateModal



// WEBPACK FOOTER //
// ./webAdmin/forms/createModal.js